export const ENVIRONMENT_DEVELOPMENT = 'DEVELOPMENT'
export const ENVIRONMENT_STAGE = 'STAGE'
export const ENVIRONMENT_PRODUCTION = 'PRODUCTION'

export const STAGE_HOSTNAME = 'plus.perf.target.com'
export const PROD_HOSTNAME = 'plus.target.com'

const stageGateway = `https://stage-api.target.com`
const prodGateway = `https://api.target.com`

const firefly = '/consumers/v1/ingest/internal/internal_app'

const APP_NAME = 'SELLER_LANDING_UI'
const STAGE_FIREFLY_URL =
  'https://stage-api.target.com/firefly_internal_events/v1/external'
const PROD_FIREFLY_URL =
  'https://api.target.com/firefly_internal_events/v1/external'

const dev = {
  environment: ENVIRONMENT_DEVELOPMENT,
  apiGatewayKey: '99ff70ddf485e4eec5e1bb5fc3c1855d86161c25',
  firefly: `${stageGateway}${firefly}`,
  //Below config for new praxis analytic lib
  appName: APP_NAME,
  analyticsApiKey: 'af9fec0c760753cfb0426547f58fb181b9e904f3',
  analyticsUrl: STAGE_FIREFLY_URL,
}

const stage = {
  ...dev,
  environment: ENVIRONMENT_STAGE,
}

const prod = {
  environment: ENVIRONMENT_PRODUCTION,
  apiGatewayKey: 'f84694eac26c36659e61b1ae79c5ef52aa424b68',
  firefly: `${prodGateway}${firefly}`,
  //Below config for new praxis analytic lib
  appName: APP_NAME,
  analyticsApiKey: '3ed35cf66db750419bbd35c078c0d59b0400edaf',
  analyticsUrl: PROD_FIREFLY_URL,
}

const envConfigs = { dev, stage, prod }

const hostname = window?.location?.hostname ?? ''

const isProd = hostname.match(new RegExp(`^${PROD_HOSTNAME}$`, 'i'))

const isStage = !isProd && hostname.match(/(stg|stage|perf|qa|dev)/i)

const appEnv =
  (isStage && 'stage') ||
  (isProd && 'prod') ||
  process.env.REACT_APP_ENV ||
  'dev'

const config = envConfigs[appEnv]

export default config
